// @flow

import React, { type Node } from 'react';
import {
  getPaymentTypeCode,
  getSafeOxxoUrl,
  getSafeVoucherUrl,
  usePendingIncomingPayment,
  redirectIfCheckForConfirmationIsEnabled,
} from '@tectonics/prs/incoming-payment';
import { ButtonWrapper, LinkButton, VariableWidthDiv } from '../commons/render-helpers';
import { Separator } from '../../../atoms';
import { HeaderText } from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';

export function RenderPaymentInstructions(): Node {
  return (
    <RenderPaymentInfoContainer
      h1Text="Instrucciones de pago"
      items={[
        {
          imgSrc: 'https://cdn.ebanx.com/images/vouchers/cobro-icon.svg',
          subText: 'Después de realizar su pago, verifique en el comprobante emitido por OXXO que aparezca escrito "Cobro de EBANX".',
        },
        {
          imgSrc: 'https://cdn.ebanx.com/images/vouchers/calendar-icon.svg',
          subText: 'La confirmación del pago puede Ilevar aproximadamente 3 días hábiles para verse reflejado en el sitio web de la compra.',
        },
        {
          imgSrc: 'https://cdn.ebanx.com/images/vouchers/duplicate-icon.svg',
          subText: 'Esta boleta es válida solamente para un código de pedido, no debe relizar un pago doble o uno de ellos será cancelado.',
        },
      ]}
    />
  );
}

export function RenderButtonArea(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment) || 'null';
  const oxxoUrl  = paymentTypeCode === 'oxxopay' ? getSafeVoucherUrl(incomingPayment): getSafeOxxoUrl(incomingPayment);
  const printButtonMessage = 'Imprimir recibo oxxo';
  const downloadButtonMessage = 'Guardar boleta oxxo en pdf';
  const mapButtonMessage = 'Ver tienda oxxo más cercana';

  return (
    <>
      <ButtonWrapper>
        <LinkButton
          inverseStyle={false}
          aria-label={printButtonMessage}
          type="primary"
          flat as="a"
          target="blank"
          href={oxxoUrl}
          contentDesktop={printButtonMessage}
          data-test-id="oxxo-print-button"
          onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) }/>
      </ButtonWrapper>
      <ButtonWrapper>
        <LinkButton
          inverseStyle={true}
          type="primary"
          aria-label={downloadButtonMessage}
          flat as="a"
          target="blank"
          href={`${oxxoUrl}&format=pdf`}
          contentDesktop={downloadButtonMessage}
          contentMobile={downloadButtonMessage}
          data-test-id="oxxo-pdf-button"
          onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) } />
      </ButtonWrapper>

      <HeaderText>Sucursales para pago</HeaderText>
      <>Presente esta boleta en cualquier tienda OXXO:</>
      <Separator direction="vertical" size="2"/>
      <VariableWidthDiv>
        <RenderProperOxxoImage />
      </VariableWidthDiv>
      <Separator direction="vertical" size="2"/>

      <LinkButton
        inverseStyle={true}
        aria-label={mapButtonMessage}
        type="primary"
        flat as="a"
        target="blank"
        href="https://print.ebanx.com/print/oxxo/map"
        contentDesktop={mapButtonMessage}
        contentMobile={mapButtonMessage} />
      </>
  );
}

function RenderProperOxxoImage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment) || 'null';
  return (
    <img height="50px" src={`https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/${paymentTypeCode}/logo.png`} alt={paymentTypeCode} />
  );
}
